// removed by extract-text-webpack-plugin
module.exports = {"wrap":"common-UserJobBanner-wrap","submitBlock":"common-UserJobBanner-submitBlock","row":"common-UserJobBanner-row","message":"common-UserJobBanner-message","inputsBreak":"common-UserJobBanner-inputsBreak","option":"common-UserJobBanner-option"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/UserJobBanner/index.css
// module id = 1780
// module chunks = 0